import bdServices125 from '../bd-services125'
import bdServices from '../bd-services'

const resumen_Services = {}

resumen_Services.getActividades_Evidencias = async function (fechaI, fechaF) {
  var currentUrl = window.location.hostname
  console.log(currentUrl)
  if (currentUrl === '10.121.40.125') {
    const data = await bdServices125.get(`reportesApp/data/actividades_GMdEvid.php?fechaI=${fechaI}&fechaF=${fechaF}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  } else {
    const data = await bdServices.get(`reportesApp/data/actividades_GMdEvid.php?fechaI=${fechaI}&fechaF=${fechaF}`)
      .then(res => res.data)
      .catch(e => console.log(e))
    return data
  }
}

export default resumen_Services


// WEBPACK FOOTER //
// ./src/services/reportes/resumen.js